module.exports = __webpack_public_path__ + "static/media/2013_jan_ped_fl_hosp.2f9f693d.jpg";